import React, { useState, useEffect, useRef } from 'react';
import { injectIntl } from 'react-intl';

import messages from '../../../locale/messages';
import Loader from '../../../components/Common/Loader/Loader';

const AddContentPage = ({ intl }) => {
  const { formatMessage } = intl;
  const [loading, setLoading] = useState(true);
  const ComponentRef = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      import('../../../components/SiteAdmin/ContentPage/AddContentPageForm')
        .then((mod) => {
          ComponentRef.current = mod.default;
          setLoading(false);
        })
        .catch((error) => {
          console.error('Failed to load AddContentPageForm:', error);
        });
    }
  }, []);

  const AddContentPageForm = ComponentRef.current;

  return (
    <Loader type="page" show={loading}>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.contentpageManagement)}</h1>
      {!loading && AddContentPageForm && <AddContentPageForm />}
    </Loader>
  );
};

export default injectIntl(AddContentPage);
